import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Divider = makeShortcode("Divider");
const TitleBlock = makeShortcode("TitleBlock");
const TextBlock = makeShortcode("TextBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Divider orientation="horizontal" size="M" className="m-0" mdxType="Divider" />
    <TitleBlock slots="heading" theme="light" className="titleBlock-align-left" mdxType="TitleBlock" />
    <h2 {...{
      "id": "adobe-pdf-embed-api"
    }}>{`Adobe PDF Embed API`}</h2>
    <TextBlock slots="text" theme="light" width="40%" className="pricing-desc align-left" mdxType="TextBlock" />
    <p>{`Enjoy complimentary access to our JavaScript API to easily embed PDFs with a few lines of code. Standardize your end-user viewing experiences with interactivity and analytics, all at no charge!`}</p>
    <TextBlock slots="text" isCentered theme="light" width="35%" className="list-points pricing-desc" mdxType="TextBlock" />
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Unlimited access at no charge.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Rich, embedded PDF viewing.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Collaboration and analytics.`}</p>
      </li>
    </ul>
    <TextBlock className="pricing-desc button-swap d-flex" slots="buttons" isCentered theme="light" width="25%" primaryOutline mdxType="TextBlock" />
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://acrobatservices.adobe.com/dc-integration-creation-app-cdn/main.html?api=pdf-embed-api"
        }}>{`Get started`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://acrobatservices.adobe.com/view-sdk-demo/index.html"
        }}>{`Try the demo`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      